class RestaurantSingle extends ViewBasic {
	constructor(options) {
		super(options);

		this.options.waypoints = [];

		this.addEvents();
		this.scrollToHash();
	}

	addEvents() {
		//Event
		$(window).on('hashchange', e => this.scrollToHash(e));
		Me.dispatch.subscribe('breakpointChanged', (e, params) => this.createWaypoints(e, params));
	}

	removeEvents() {
	}

	createWaypoints(e, params){
		var view = this;

		if (this.options.waypoints.length != 0) {
			this.resetWaypoints();
		}

		if(params.breakpoint != '767-' && params.breakpoint != '768-958' && params.breakpoint != '959-1023') {

			this.$('.aside-related-content .section').each(function(index,value){
				let waypoint = new Waypoint({
					element: $(value),
					offset: '30%',
					handler: function (direction) {
						if (direction == 'down') {
							view.updateURLState(this.element.find('[data-anchor]').attr('data-anchor'))
						}
					}
				});

				let waypointDown = new Waypoint({
					element: $(value),
					offset: -$(value).height() + 300,
					handler: function (direction) {
						if (direction == 'up') {
							view.updateURLState(this.element.find('[data-anchor]').attr('data-anchor'))
						}
					}
				});

				view.options.waypoints.push(waypoint);
				view.options.waypoints.push(waypointDown);
			})

		}
	}
	resetWaypoints(){
		//remove all waypoints
		while(this.options.waypoints.length != 0){
			this.options.waypoints[0].destroy();
			this.options.waypoints.shift();
		}
	}

	scrollToHash(e) {
		if(e){
			e.preventDefault();
		}

		if(this.$('[data-anchor="'+ location.hash.replace('#','') +'"]').length != 0){
			$('html, body').animate({
				scrollTop: (this.$('[data-anchor="'+ location.hash.replace('#','') +'"]').offset().top - 200)
			},400);
		}
	}

	updateURLState(pHash){
		window.history.replaceState(null,null, '#'+ pHash);
		Me.dispatch.emit('scrollToAnchor', this);
	}
}